/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState } from 'react'
import { Pagination, Carousel } from 'antd'
import { chunk } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import { CarouselRef } from 'antd/lib/carousel'
import {
    useAppDispatch,
    useAppSelector,
} from '../../../../store/hooks/AppHooks'
import Loading from '../../Loading'
import { ArtistGroupActionType } from '../../../../store/constant/group.const'
import useCreatorDetail from '../../../../hook/creator/useCreatorDetail'
import useCreatorNews from '../../../../hook/creator/useCreatorNews'
import { BG_TYPE_COLOR, DEFAULT_NEWS_LIMIT } from '../../../../utils/constant'
import useCreatorSettingColor, {
    COLOR_KEYS,
} from '../../../../hook/creator/useCreatorSettingColor'
import { getBackgroundCss } from '../../../../utils/creatorUtil'
import CreatorComponent from '../../../common/Creator/CreatorComponent'
import useCreatorSettingPreviewImg from '../../../../hook/creator/useCreatorSettingPreviewImg'
import NotFoundPage from '../../NotFoundPage'
import next from '../../../../assets/images/chevron-right.svg'
import prev from '../../../../assets/images/chevron-left.svg'
import NewsCarouselItem from './NewsCarouselItem'

type Props = {
    isArtist: boolean
}
const NewsList = ({ isArtist }: Props): JSX.Element => {
    const { slug } = useParams<{ slug: string }>()
    const dispatch = useAppDispatch()
    const history = useHistory<{ currentPage?: number }>()
    const { creatorCms, isLoading, isShow404Page } = useCreatorDetail(
        slug,
        isArtist
    )
    const { settingColor } = useCreatorSettingColor(creatorCms)
    const { previewImages } = useCreatorSettingPreviewImg(creatorCms)
    const {
        artistNews,
        groupNews,
        total,
        isLoading: isLoadingNews,
    } = useCreatorNews(creatorCms, isArtist, DEFAULT_NEWS_LIMIT)
    const listNews = isArtist ? artistNews : groupNews
    const groupCmsIdCurrent = useAppSelector(
        (state) => state.artistGroup.currentGroupCmsId
    )
    const isGroupFetched = useAppSelector(
        (state) => state.artistGroup.isFetched
    )
    const carouselRef = React.useRef<CarouselRef>(null!)
    const [currentSlide, setCurrentSlide] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    const handleBackToTop = () => {
        if (isArtist) {
            history.push(`/portal/artist/${slug}`)
        } else {
            history.push(`/groups/${groupCmsIdCurrent}`)
        }
    }

    useEffect(() => {
        if (isGroupFetched) {
            dispatch({
                type: ArtistGroupActionType.fetchNews,
            })
        }
    }, [dispatch, isGroupFetched])

    const newsArray = listNews?.map((ele: any) => {
        const url = isArtist
            ? `/portal/artist/${slug}/news/${ele?.id}`
            : `/groups/${groupCmsIdCurrent}/news/${ele?.id}`

        return {
            id: ele?.id,
            title: ele?.title,
            content: ele?.content,
            publish_at: ele?.publishAt,
            url,
        }
    })

    const handleNextSlide: () => void = () => {
        carouselRef.current.next()
    }

    const handlePreviousSlide: () => void = () => {
        carouselRef.current.prev()
    }

    const gotoSlide: (num: number) => void = (num) => {
        if (currentSlide !== num - 1) {
            carouselRef.current?.goTo(num - 1)
            setCurrentSlide(num - 1)
            setCurrentPage(num)
        }
    }

    const handleChangePagination = (pageNumber: number) => {
        gotoSlide(pageNumber)
    }

    const listRenderer = chunk(newsArray ?? [], 5).map((newGroup) => (
        <div>
            {newGroup.map((news) => {
                return (
                    <NewsCarouselItem news={news} settingColor={settingColor} />
                )
            })}
        </div>
    ))

    const PaginationStyle = () => (
        <style>{`
            .ant-pagination-prev,
            .ant-pagination-next,
            .ant-pagination-item {
                border: 1px solid ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                        : settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                } !important;
                color: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                        : settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                } !important;
                background: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY]
                              ?.hex
                        : 'transparent'
                } !important;
            }
            .ant-pagination-item-container:hover,
            .ant-pagination-prev:hover,
            .ant-pagination-next:hover,
            .ant-pagination-item:hover,
            .ant-pagination-item-active {
                border: 1px solid ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY]
                              ?.hex
                        : settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                } !important;
                color: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY]
                              ?.hex
                        : '#ffffff'
                } !important;
                background: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                        : '#000000'
                } !important;
            }
            .ant-pagination-disabled {
                opacity: 0.3;
            }
            .ant-pagination-item-link {
                border: none !important;
                color: inherit !important;
                background: none !important;
            }
            .ant-pagination-item-ellipsis {
                color: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]?.hex
                        : '#ffffff'
                } !important;
            }
            .ant-pagination-item-link-icon {
                color: ${
                    creatorCms?.backgroundType === BG_TYPE_COLOR
                        ? settingColor?.[COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY]
                              ?.hex
                        : '#ffffff'
                } !important;
            }
            .ant-pagination-item-container,
            .ant-pagination-prev,
            .ant-pagination-next,
            .ant-pagination-item {
                border-radius: 5px;
            }
        `}</style>
    )

    if (isLoading || isLoadingNews) {
        return (
            <CreatorComponent>
                <Loading isGlobalLoading />
            </CreatorComponent>
        )
    }

    return isShow404Page ? (
        <NotFoundPage
            creator={creatorCms}
            settingColor={settingColor}
            previewImages={previewImages}
            backgroundType={creatorCms?.backgroundType}
        />
    ) : (
        <CreatorComponent>
            <section className="portal-news__index portal__page group-news-list">
                <div
                    className="portal__page__container"
                    style={{
                        color:
                            settingColor?.[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY]
                                ?.hex ?? '',
                        background: creatorCms?.backgroundType
                            ? getBackgroundCss(
                                  creatorCms.backgroundType,
                                  settingColor?.[
                                      COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY
                                  ]?.hex,
                                  creatorCms?.backgroundImage?.url
                              )
                            : 'none',
                    }}
                >
                    <div className="mx-auto max-w-6xl">
                        <h3
                            className="flex justify-start items-center gap-2 border-b-2 text-3xl font-bold"
                            style={{
                                borderColor:
                                    settingColor?.[
                                        COLOR_KEYS.COLOR_TEXT_GENERAL_KEY
                                    ]?.hex ?? '',
                                color: 'inherit',
                                marginBottom: '2rem',
                                paddingBottom: '0.5rem',
                            }}
                        >
                            NEWS
                        </h3>

                        <div className="relative px-2">
                            <Carousel
                                dots={false}
                                infinite
                                swipeToSlide={false}
                                autoplay={false}
                                draggable
                                ref={carouselRef}
                                slidesToShow={1}
                                slidesToScroll={1}
                                afterChange={(current) => {
                                    setCurrentSlide(current)
                                    setCurrentPage(current + 1)
                                }}
                            >
                                {listRenderer}
                            </Carousel>
                            {newsArray.length > 5 && (
                                <>
                                    <button
                                        type="button"
                                        className="absolute w-45"
                                        style={{
                                            bottom: '50%',
                                            left: '-25px',
                                        }}
                                        onClick={handlePreviousSlide}
                                    >
                                        <img
                                            className=""
                                            src={prev}
                                            alt="Button-prev"
                                        />
                                    </button>
                                    <button
                                        type="button"
                                        className="absolute w-45"
                                        style={{
                                            bottom: '50%',
                                            right: '-25px',
                                        }}
                                        onClick={handleNextSlide}
                                    >
                                        <img
                                            className=""
                                            src={next}
                                            alt="Button-next"
                                        />
                                    </button>
                                </>
                            )}
                        </div>

                        {listNews && total > 5 ? (
                            <>
                                {PaginationStyle()}

                                <div
                                    className="flex justify-center space-x-2 text-sm portal-news__paginate"
                                    style={{ marginTop: '0.5rem' }}
                                >
                                    <Pagination
                                        total={total}
                                        current={currentPage}
                                        onChange={handleChangePagination}
                                        pageSize={5}
                                        showLessItems
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}

                        <div
                            className="text-left"
                            style={{ marginTop: '1.5rem' }}
                        >
                            <button type="button" onClick={handleBackToTop}>
                                &lt; トップへ戻る
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </CreatorComponent>
    )
}

export default NewsList
